export type ChatMessage = {
  id: number;
  user: string;
  avatar: string;
  text: string;
  time: string;
  tag?: string;
};

export type ChatRoom = {
  id: string;
  name: string;
  desc: string;
  online: number;
  icon: string;
  hot: boolean;
};

export const chatRooms: ChatRoom[] = [
  { id: "main", name: "主瓜田 · 综合讨论", desc: "所有热点都会在这里第一时间同步", online: 3281, icon: "ri-fire-line", hot: true },
  { id: "variety", name: "综艺蹲守屋", desc: "录制路透、名场面、节目复盘", online: 1264, icon: "ri-mic-line", hot: true },
  { id: "film", name: "追剧不困群", desc: "新剧开播、口碑走向、结局讨论", online: 908, icon: "ri-film-line", hot: false },
  { id: "etiquette", name: "围观姿势研究所", desc: "一起练习理性吃瓜的正确方式", online: 573, icon: "ri-shield-star-line", hot: false },
  { id: "twist", name: "反转档案馆", desc: "专门整理时间线与后续追踪", online: 442, icon: "ri-arrow-go-back-line", hot: false },
];

export const chatMessages: ChatMessage[] = [
  { id: 1, user: "瓜田守望者", avatar: "ri-user-3-line", text: "今晚八点据说还有新进展，我先占个位蹲着。", time: "20:14", tag: "楼长" },
  { id: 2, user: "路透小分队", avatar: "ri-user-5-line", text: "刚才那边更新了一条物料，看起来是补录片段，语气比之前松多了。", time: "20:15" },
  { id: 3, user: "冷静观察员", avatar: "ri-user-6-line", text: "先别急着下结论，等官方口径出来再判断吧，上次就是太快了。", time: "20:16" },
  { id: 4, user: "时间线搬运工", avatar: "ri-user-4-line", text: "我把前几天的时间点重新排了一遍，发现中间其实隔了三天，不是同一天。", time: "20:18", tag: "考据" },
  { id: 5, user: "夜猫子小陈", avatar: "ri-user-2-line", text: "楼上这个整理太及时了，果然还是得看时间线。", time: "20:18" },
  { id: 6, user: "追更不停的小Y", avatar: "ri-user-star-line", text: "有没有人一起等九点？我开个倒计时，到了喊我。", time: "20:20" },
  { id: 7, user: "围观新人", avatar: "ri-user-add-line", text: "第一天来，请问这边一般都聊到几点呀？", time: "20:21" },
  { id: 8, user: "瓜田守望者", avatar: "ri-user-3-line", text: "欢迎新人～一般到十二点都还有人，慢慢就习惯了哈哈。", time: "20:22", tag: "楼长" },
  { id: 9, user: "冷静观察员", avatar: "ri-user-6-line", text: "刚看到澄清了，和之前的说法有出入，大家记得回头对照一下。", time: "20:26" },
  { id: 10, user: "时间线搬运工", avatar: "ri-user-4-line", text: "收到，我更新到档案馆里了，这次反转挺典型，值得复盘。", time: "20:27", tag: "考据" },
];

export const quickReplies = [
  "蹲一个后续",
  "有没有时间线整理？",
  "先别急，等等官方口径",
  "这条反转我有印象",
];

export const onlineNames = ["瓜田守望者", "路透小分队", "冷静观察员", "时间线搬运工", "追更不停的小Y", "夜猫子小陈"];